import {
  type Verdict,
  GetExamCourseVerdictDocument,
  useGetExamCourseVerdictQuery,
  useUpdateOrCreateExamCourseVerdictMutation,
} from '@exam-management/graphql';
import { createContext, useMemo } from 'react';

import type { ReviewResultContextData } from '../../types';

import type { ReviewResultProviderProps } from './types';

export const ReviewResultContext = createContext<ReviewResultContextData | undefined>(undefined);

export default function ReviewResultProvider(props: Readonly<ReviewResultProviderProps>) {
  const { children, taskId, entityId = '', entityType } = props;

  const input = {
    entityId: entityId,
    entityType: entityType,
    taskId: taskId,
  };

  const [review] = useUpdateOrCreateExamCourseVerdictMutation({
    refetchQueries: [
      {
        query: GetExamCourseVerdictDocument,
        variables: {
          getExamCourseVerdictInput: input,
        },
      },
    ],
  });

  const {
    data,
    loading: isLoading,
    error,
  } = useGetExamCourseVerdictQuery({
    variables: { getExamCourseVerdictInput: input },
    fetchPolicy: 'cache-and-network',
  });

  const contextValue = useMemo(
    () => ({
      verdict: {
        data: data?.excGetExamCourseVerdict.verdict.verdict,
        loading: isLoading,
        error: error ?? null,
      },
      reviewQSetQuestion: (data: { verdict: Verdict }) => {
        review({
          variables: {
            updateOrCreateExamCourseVerdictInput: {
              ...input,
              verdict: data.verdict,
            },
          },
        });
      },
    }),
    [data, isLoading, error],
  );

  return (
    <ReviewResultContext.Provider value={contextValue}>{children}</ReviewResultContext.Provider>
  );
}
